//@ts-check
/**
 * 
 * @param {Fox} fox 
 */
module.exports = (fox) => {
	const $ = fox.jQuery;

	fox.registerWidget('Tips_Form', {
		configure: function () {
			this.minCustomPriceAmount = 2; //$
			this.recomendedCustomPriceAmount = 10; //$
			this.paymentPending = [];

			this.registerOptions('', {
				autoRender: true,
				widgets: {
					tipsDl: {
						widget: 'Datalayer',
						method: 'tips.getTips',
						cacheChannel: 'site'
					},
					tipItems: {
						widget: 'Grid',
						container: '.tips-list-container',
						dataLayer: '@parent #tipsDl',
						autoRender: true,
						list: {
							'tpl.row': 'sitepage_tips_form_item',
							hooks: {
								onAddedToDom: () => this._updateForm(),
							},
							handleDom: {
								handleCustomPriceFocus: {
									target: '[name="custom_price"]',
									event: 'focus',
									callback: function (el) {
										var form = this.getParent()
											.getParent()
											.rwom1('#form');

										form.setValue('tips', fox.dom.wrap(el).attr('alias'));
									}
								},
								handleCustomPriceBlur: {
									target: '[name="custom_price"]',
									event: 'blur',
									callback: function (el) {
										var id = fox.dom.wrap(el).attr('alias');
										var target = fox.dom.selectFirst('[data-amount][data-id="' + id + '"]');

										if (!target) return;

										fox.dom.wrap(target).attr('data-amount', el.value);
									}
								}
							}
						}
					},
					errors: {
						widget: 'List',
						tpl: {
							row: 'sitepage_tips_form_error_row'
						},
						container: '#errors.errors',
						autoRender: false
					},
					form: {
						widget: 'Form',
						loadValuesOnRun: true,
						formElements: {
							'message.element': '[name=tipsMessage]',
							'amount.element': '[name=custom_price]',
							'amount.defaultValue': this.recomendedCustomPriceAmount,
							'tips.element': '[name=tips]',
							'tips.autoApply': true
						},
						resetOnBuilt: false,
						'hooks.onStartSubmit': '@parent:validateData'
					},
					prepareApi: {
						widget: 'Api',
						method: 'tips.prepare'
					},
					billerOptionsForm: {
						widget: 'Widget',
						'embed.widget': '@parent @parent',
						'embed.container': '#biller-form-container',
						template: 'sitepage_tips_form_billing',
						billerFormSelector: '#biller-form',
						widgets: {
							optionsList: {
								widget: 'List',
								autoRender: true,
								container: '#biller-form',
								tpl: {
									row: 'sitepage_tips_form_billing_row'
								}
							}
						},
						handleWom: {
							onListInDom: {
								event: 'addedToDom',
								widget: '#optionsList',
								callback: '@parent:_sendBillerForm'
							}
						},
						autoRender: false
					},

					successPopup: {
						widget: 'Dialog',
						template: '',
						dialog: {
							closeText: '',
						},
						widgets: {
							tipsPopupContainer: {
								widget: 'Widget',
								widgets: {
									content: {
										widget: 'Widget',
										template: 'popup_thanks'
									}
								}
							}
						}
					},
					errorPopup: {
						widget: 'Dialog',
						template: '',
						dialog: {
							closeText: '',
						},
						widgets: {
							tipsPopupContainer: {
								widget: 'Widget',
								widgets: {
									content: {
										widget: 'Widget',
										template: 'popup_wrong',
										'handleDom.hide': {
											target: 'a',
											callback: '@parent @parent:hide'
										}
									}
								}
							}
						},
					},
					confirmPopup: {
						widget: 'Dialog',
						template: '',
						dialog: {
							closeText: ''
						},
						widgets: {
							tipsPopupContainer: {
								widget: 'Widget',
								widgets: {
									content: {
										widget: 'Widget',
										template: 'popup_attention',
										'handleDom.confirm': {
											target: '.confirm',
											event: 'click',
											callback: '@parent @parent @parent:submit'
										}
									}
								}
							}
						}
					}
				},
				handleWom: {
					tipsPaymentSuccess: {
						event: 'inboxSocketEventTips:unlock',
						widget: '@root #socket',
						callback: 'tipsPaymentSuccess',
						params: {
							alwaysActive: true
						}
					}
				}
			});

			this.registerOptions('~.Dialog #tipsPopupContainer', {
				template: 'popup_container',
				autoRender: true,
				'handleDom.close': {
					target: '.close',
					event: 'click',
					callback: '@parent:hide'
				}
			});

			this.registerOptions('~.Dialog #tipsPopupContainer #content', {
				autoRender: true,
				container: '#popup-widget-container',
				'handleDom.close': {
					target: '.close',
					event: 'click',
					callback: '@parent @parent:hide'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.userData = {};
			this.api = null;
			this.callParent('init', arguments);

			if (fox.isEmpty(this.getMemberInfo())) {
				this.registerOptions('#form', {
					formElements: {
						'login.element': '[name=login]',
						'login.autoApply': true,
						'email.element': '[name=email]',
						'email.autoApply': true
					}
				});
			}
		},

		running: function () {
			if (!this.prepareApi) {
				this.prepareApi = this.rwom1('#prepareApi');
			}

			this.confirmPopup = this.wom1('#confirmPopup');
			this.successPopup = this.wom1('#successPopup');
			this.errorPopup = this.wom1('#errorPopup');

			this.handleEvent('#form', 'submit', 'onSubmit');
			this.callParent('running', arguments);
		},

		onSubmit: function (userData) {
			if (!this._isValid) {
				return;
			}

			this.userData = userData;

			if (!this.confirmPopup) {
				console.warn('Confiramation popup doesn\'t exist');
				return;
			}

			this.confirmPopup.wom1('#tipsPopupContainer #content')
				.setTemplateOptions({ amount: this._getAmount() })
				.render();

			this.confirmPopup.show();
		},

		submit: function () {
			this.requireEmbeddedWidget('form').ignoreSubmit(true);

			var transactionParams = {
				tipId: this.userData.tips,
				amount: this.userData.amount
			};

			if (this.userData.login && this.userData.email) {
				transactionParams.login = fox.trim(this.userData.login);
				transactionParams.email = fox.trim(this.userData.email);
			}

			if (this.userData.message) {
				transactionParams.message = this.userData.message;
			}

			if (this.userData.targetId && this.userData.subject) {
				transactionParams.targetId = this.userData.targetId;
				transactionParams.subject = this.userData.subject;
			}

			transactionParams = fox.mixin(transactionParams, this.getOption('preparedTransactionParams'));

			const showCbInPopup = this.getOption('showCbInPopup');
			const showCbCallback = fox.isBoolean(showCbInPopup) ?
				this.showCbWindow :
				fox.isFunction(showCbInPopup) ?
					(...args) => showCbInPopup.apply(this, args) :
					null;

			const promise = this.prepareTransaction(transactionParams).then((res) => {
				if (showCbCallback)
					return new fox.Promise(resolve => {
						return this.onPrepareSuccess(res, transactionParams.tipId, resolve);
					});

				return this.onPrepareSuccess(res, transactionParams.tipId);
			}).catch((...args) => this.onPrepareFailed(...args));

			if (showCbCallback)
				return showCbCallback(promise);
		},

		tipsPaymentSuccess: function (res) {
			var args = Array.prototype.slice.call(arguments);

			if (this.prepareTransactionInProgress === true) {
				return this.prepareApi.wait('@this', 'success', { prefix: 'waitForApiSuccess' })
					.then(fox.bind(function () {
						this.tipsPaymentSuccess.apply(this, args);
					}, this));
			}

			res = res.answer;

			var indx = this.paymentPending.indexOf(Number(res));

			if (indx !== -1) {
				this.paymentPending.splice(indx, 1);

				if (this.isActive()) {
					this.hookWrapper('showSuccessPopup');
				}
			}
		},

		prepareTransaction: function (formData) {
			$(this.rwom1('#errors').getOption('container')).hide();
			var extParams = fox.Navigator.getAll();
			delete extParams[0];

			fox.each(extParams, function (v, k) {
				if (!fox.isSet(formData[k])) {
					formData[k] = v;
				}
			});

			this.confirmPopup.hide();

			this.prepareTransactionInProgress = true;

			return this.prepareApi.psend(formData);
		},

		onPrepareTransaction: function (data) {
			$(this.rwom1('#errors').getOption('container')).hide();
			var fields = [];

			fox.each(data.added_fields, function (v, k) {
				fields.push({ key: k, val: v });
			});

			this.rwom1('#billerOptionsForm #optionsList').setCollection(fields);
			this.rwom1('#billerOptionsForm')
				.setTemplateOptions({
					billerUrl: data.submit_url,
					formMethod: data.form_method
				})
				.render();
		},

		showCbWindow: function (promise) {
			var cbPopup = this.wom1('#cbPaymentPopup');

			if (!cbPopup) {
				cbPopup = this.embedWidget('cbPaymentPopup', 'CBPaymentPopup', {});

				cbPopup.run();
			}

			return cbPopup.show(promise.then((data) => {
				const url = data.submit_url + '?' + fox.toQueryString(data.added_fields);

				return { url };
			}));
		},

		onPrepareFailed: function (data) {
			this.prepareTransactionInProgress = false;

			var err = fox.objectGet(data, 'answer') || fox.objectGet(data, 'params.answer');
			var messages = [];

			if (data.error === 'jsonParse' || fox.isEmpty(data)) {
				console.warn('bad internet connection');
			} else if (fox.isSet(err.type) && (err.type === 6)) {
				fox.each(err.data, function (items) {
					fox.each(items, function (item) {
						messages.push({
							message: item.message
						});
					});
				});
			}

			this.showMessages(messages);

			this.setTplOptionToErrorPopup(err.code);
			this.errorPopup.show();

			this.requireEmbeddedWidget('form')
				.enableAllElements()
				.ignoreSubmit(false);

			this.dispatchEvent('onPrepareFailed', err);
		},

		onPrepareSuccess: function (r, tipId, resolver) {
			this.prepareTransactionInProgress = false;

			function pendingPayment(tipId) {
				this.rwom1('#form')
					.enableAllElements()
					.ignoreSubmit(false);

				this.paymentPending.push(Number(tipId));
			}

			r = r.params.answer.response;

			if (r.submit_url) {
				if (resolver) {
					resolver(r);
				} else {
					this.onPrepareTransaction(r);
				}

				return pendingPayment.call(this, tipId);
			} else if (r === true || r === 'Event successfully processed') {
				if (resolver)
					resolver(true);

				return pendingPayment.call(this, tipId);
			}

			throw new Error('Payment error');
		},

		showSuccessPopup: function () {
			var nickname = fox.isEmpty(this.getMemberInfo()) ? this.userData.login : this.getMemberInfo('login');
			this.successPopup.render();
			this.successPopup.wom1('#tipsPopupContainer #content')
				.setTemplateOptions({ name: nickname })
				.render();

			this.successPopup.show();
			this.dispatchEvent('showedSuccessPopup');
		},

		showMessages: function (messages) {
			this.rwom1('#errors')
				.setCollection(messages)
				.render();
			$(this.rwom1('#errors').getOption('container')).show();
		},

		_updateForm: function () {
			var form = this.rwom1('#form');

			fox.each(this.rwom1('#tipsDl').getCollection(), function (item, key) {
				var chkbx = fox.dom.selectFirst('#tip_' + (this.getOption('useIdForDomId') === true ? item.id : (key + 1)), this.element);
				fox.dom.removeClass('checked', chkbx.parentNode);

				if (item.isDefault) {
					chkbx.checked = true;
					fox.dom.addClass('checked', chkbx.parentNode);
				}
			}, this);

			form._runSelectors();
			form.createWidgetsFromSelectors();

			this.window.setTimeout(fox.bind(function () {
				var el = form.getFormElement('amount')[0];

				if (!el) {
					return;
				}

				form.setValue('amount', this.recomendedCustomPriceAmount);

				var id = fox.dom.wrap(el).attr('alias');
				var target = fox.dom.selectFirst('[data-amount][data-id="' + id + '"]');

				fox.dom.wrap(target).attr('data-amount', el.value);
			}, this), 200);

		},

		_error: function (text) {
			$(this.rwom1('#errors').getOption('container')).text(text).show();

		},

		_sendBillerForm: function () {
			if (fox.count(this.rwom1('~#billerOptionsForm #optionsList').getCollection())) {
				var bof = this.rwom1('#billerOptionsForm');

				/** @type {HTMLFormElement} */
				const form = bof.dom1(bof.getOption('billerFormSelector'));

				form.submit();
			}
		},

		_getAmount: function () {
			var result = false;
			var elems = fox.dom.select('label[data-amount]');

			fox.each(elems, function (el) {
				el = fox.dom.wrap(el);

				if (el.attr('data-id') === this.userData.tips) {
					result = el.attr('data-amount');
				}
			}, this);

			return result;
		},

		validateData: function () {
			this._isValid = false;
			var result = {
				email: false,
				login: false,
				custom: false
			};

			if (fox.isEmpty(this.getMemberInfo())) {
				result.email = this._validateEmail();
				result.name = this._validateName();
			} else {
				result.email = true;
				result.name = true;
			}

			result.custom = this._validateCustomValue();
			if (result.name && result.email && result.custom) {
				this._isValid = true;
				this.wom1('#form').dispatchEvent('submit', this._preparedValues);
				return;
			}
		},

		_validateCustomValue: function () {
			if (!this.wom1('#form #amount')) {
				return true;
			}

			var amount = this.wom1('#form').getValue('amount');
			var elem = this.dom1('[custom-price]');
			/** @type {any} */
			var input;
			var regExp = /^[0-9]+(\.?[0-9]+)?$/;

			if (elem) {
				input = fox.dom.selectFirst('[name="tips"]', elem);
			}

			if (!input) {
				return false;
			}
		
			if (input.checked) {
				if (!amount || !amount.length || !amount.match(regExp)) {
					this.toggleError('custom_price', false);
					return false;
				}

				if (amount.match(regExp)) {
					amount = this.window.parseInt(amount);

					if (amount >= this.minCustomPriceAmount && amount <= 99999) {
						this.toggleError('custom_price', true);
						return true;
					}

					this.toggleError('custom_price', false);
					return false;
				}
			}

			return true;
		},

		_validateEmail: function () {
			var
				regExp = new RegExp('^[a-zA-Z0-9#\!\$%&\'\*\+\/=\?\^_`\{\}\|~-]+(?:\.[a-z0-9#\!\$%&\'\*\+\/=\?\^_`\{\}\|~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$'),
				el = fox.dom.selectFirst('[name="email"]', this.rwom1('#form').getContainer());

			if (!el) {
				return false;
			}

			if (this.isNotEmpty('email') && el.value.match(regExp)) {
				this.toggleError('email', true);
				return true;
			}

			this.toggleError('email', false);
			return false;
		},

		_validateName: function () {
			if (this.isNotEmpty('login')) {
				this.toggleError('login', true);
				return true;
			}

			this.toggleError('login', false);
			return false;
		},

		toggleError: function (name, state) {
			var el = fox.dom.selectFirst('[name="' + name + '"]', this.rwom1('#form').getContainer());

			if (!el) {
				return;
			}

			fox.dom[(!state ? 'addClass' : 'removeClass')]('error', el);
			this.hookWrapper('handleErrorToggle', { state: state, el: el });
		},

		isNotEmpty: function (name) {
			return fox.dom.selectFirst('[name="' + name + '"]', this.rwom1('#form').getContainer()).value.length;
		},

		handleErrorToggle: function () { },

		getMemberInfo: function (field) {
			var pm = this.wom1('@root #permissionManager');

			if (pm) return pm.getMemberInfo(field);

			return field ? fox.site.member && fox.site.member.getObjectValue(field) : fox.site.member;
		},

		setTplOptionToErrorPopup: function (code) {
			var w = this.errorPopup.wom1('~#content');

			w.setTemplateOptions({});

			//user already exists
			if (code === 3003) {
				w.setTemplateOptions({ errorAlias: 'userExists' });
			}

			w.render();
		}
	}, 'Widget');
}



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/tips/form.es.js